/** Shared completion presentation derived only from canonical activity fields.
 * @module apps/web/src/components/activities/ActivityDone
 */
import type { TaskUI } from '@fluxability/types';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Render completion from stored status/progress, never inferred from elapsed or scheduled time. */
export function activityIsDone(task?: Partial<Pick<TaskUI, 'status' | 'completionPercent'>>): boolean {
  return task?.status === 'done' || task?.status === 'completed' || task?.completionPercent === 100;
}

/** Visible completion text and icon on an opaque app-owned surface, including compact calendars. */
export function ActivityDone({ compact = false }: {
  /** Fit the label within the calendar's twelve-pixel compact title line. */
  compact?: boolean;
}) {
  return (
    <span className={cn(
      'inline-flex shrink-0 items-center gap-0.5 rounded bg-emerald-100 font-medium text-emerald-950 dark:bg-emerald-950 dark:text-emerald-100',
      compact ? 'px-0.5 text-[9px] leading-3' : 'px-1.5 py-0.5 text-[10px] leading-3'
    )} data-activity-done>
      <Check aria-hidden="true" className={compact ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
      Done
    </span>
  );
}
